// Copyright © 2024 Ory Corp
// SPDX-License-Identifier: Apache-2.0

import apple from "./apple.svg"
import auth0 from "./auth0.svg"
import discord from "./discord.svg"
import facebook from "./facebook.svg"
import github from "./github.svg"
import gitlab from "./gitlab.svg"
import google from "./google.svg"
import linkedin from "./linkedin.svg"
import microsoft from "./microsoft.svg"
import slack from "./slack.svg"
import spotify from "./spotify.svg"
import yandex from "./yandex.svg"
import x from "./x.svg"

const logos: Record<string, typeof apple> = {
  apple,
  auth0,
  discord,
  facebook,
  github,
  gitlab,
  google,
  linkedin,
  microsoft,
  slack,
  spotify,
  yandex,
  x,
}
export default logos
